// @ts-nocheck
import React from 'react';
import { useConfirmDialog } from '@bingads-webui-campaign-react/confirmation-dialog-v2';

export interface I18n {
  getString: (key: string, params?: any) => string
}

export interface ProtectedLinkProps {
  i18n: I18n;
  onNavigation: () => void;
  dialogProps: any;
  enabled?: boolean;
  children: React.ReactNode;
  className: string | undefined;
}

export const ProtectedLink: React.FC<ProtectedLinkProps> = ({
  i18n, onNavigation, children, dialogProps = {}, enabled, className,
}) => {
  const [
    dialogView,
    showDialog,
    shouldShow,
  ] = useConfirmDialog({
    ...dialogProps,
    onConfirm: onNavigation,
    className: 'external-dialog',
    i18n,
  });

  const onClick = (e) => {
    e.stopPropagation();
    if (enabled) {
      showDialog();
    } else {
      onNavigation();
    }
  };

  return (
    <div className={className}>
      {children && React.Children.map(children, child =>
        React.cloneElement((child), {
          onClick,
        }))}
      {shouldShow && dialogView}
    </div>
  );
};

ProtectedLink.defaultProps = {
  enabled: false,
};
